export default function NotFound() {
  return <center>
    <img src="notfound.svg" alt="Not Found" />
    <div>What you are looking is yet to be shared!</div>
  </center>
}
